export default "__VITE_ASSET__Co9rdYTD__"